import client from '../client';
import { BASE_ENDPOINTS, SERVICES, VERSIONS } from '../common/constants';

// Define the base endpoint for project management
const PROJECT_MANAGEMENT_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.MANAGEMENT,
  VERSIONS.V1,
  'management/project', // Resource name for project management
  false // No tenant ID in the base URL
);

const FARMLAND_MANAGEMENT_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.MANAGEMENT,
  VERSIONS.V1,
  'management/farmland', // Resource name for project management
  false // No tenant ID in the base URL
);
const FARMLANDS_MANAGEMENT_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.MANAGEMENT,
  VERSIONS.V1,
  'management/farmlands', // Resource name for project management
  false // No tenant ID in the base URL
);

export const getProjectLists = ({ tenant, country, state, cluster }) =>
  client.get(`${PROJECT_MANAGEMENT_BASE}/list`, {
    params: {
      tenant,
      ...(country && { country }),
      ...(state && { state }),
      ...(cluster && { cluster })
    }
  });

export const getCountries = () =>
  client.get(`${PROJECT_MANAGEMENT_BASE}/countries/`);

export const getStates = country =>
  client.get(`${PROJECT_MANAGEMENT_BASE}/states/${country}`);

export const createProject = data =>
  client.post(`${PROJECT_MANAGEMENT_BASE}/submitRequest/`, data);

export const getProjectDetails = ({ tenant, request_id }) =>
  client.get(`${PROJECT_MANAGEMENT_BASE}/`, {
    params: {
      tenant,
      request_id
    }
  });

export const updateProject = data =>
  client.put(`${PROJECT_MANAGEMENT_BASE}/update/`, data);

export const deleteProject = ({ tenant, request_id }) =>
  client.delete(`${PROJECT_MANAGEMENT_BASE}/delete/`, {
    params: {
      tenant,
      request_id
    }
  });

export const startProcessing = ({ tenant, request_id }) =>
  client.post(`${PROJECT_MANAGEMENT_BASE}/queue/${tenant}/${request_id}`);

export const getBlockList = cluster =>
  client.get(`${FARMLANDS_MANAGEMENT_BASE}/blocks/list/${cluster}`);

export const getBlockDetails = ({ tenantId, blockId }) =>
  client.get(`${FARMLAND_MANAGEMENT_BASE}/blocks/${tenantId}/${blockId}`);
